import React from 'react';
import { C } from '../shared/constants';

export default function Bar() {
  return <div style={{ width:4, height:24, borderRadius:2, background:C.triGrad, flexShrink:0 }}/>;
}
